import React from 'react'

import FormRadio from '@f/elements/FormRadio'

const FilterRadio = props => {
  const handleRadio = event => {
    const target = event.target
    const currentParam =
      target.name === 'expansion_stage'
        ? `${target.value}__range`
        : `${target.name}_in`
    const defaultValue = props.filter.default

    let params = { ...props.params }

    if (props.filter.name === 'expansion_stage') {
      let currentExpansionStage = {
        name: '',
        value: '12500,'
      }

      for (let param in params) {
        if (param.indexOf(defaultValue) > -1) {
          currentExpansionStage = { name: param, value: params[param] }
        }
      }

      if (currentExpansionStage.name) {
        delete params[currentExpansionStage.name]
      }

      if (
        target.value !== defaultValue ||
        currentExpansionStage.value !== '12500,'
      ) {
        params[currentParam] = currentExpansionStage.value
      }
    } else {
      params[currentParam] = target.value

      if (params[currentParam] === defaultValue) {
        delete params[currentParam]
      }
    }

    props.updateParams(params)
  }

  return (
    <FormRadio
      name={props.filter.name}
      radioValue={props.option.id}
      theme='basic'
      label={props.option.name}
      className='[ f-c-bo-neu025 ] is-full-width'
      labelClassName='[ f-d-inbl f-t-body f-m-a-005 f-m-l-010 f-c-fo-pri ]'
      onChange={handleRadio}
      defaultChecked={props.option.id == props.filter.currentValue}
      wtData={{
        radiobutton: {
          location: 'filter-panel'
        }
      }}
    />
  )
}

export default FilterRadio
